import { DateTime } from "luxon";

export const formatCountDownTime = (time: number): string => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const diffDateAndNow = (startDate: string) => {
  const target = DateTime.fromISO(startDate);
  const current = DateTime.now().setZone("system").setZone("UTC", { keepLocalTime: true });

  return Math.round(target.diff(current, "seconds").seconds);
};

export const isDaysRemaining = (timeLeft: number) => {
  const days = 3 * 24 * 60 * 60;
  return timeLeft >= days;
};
